import { VALIDATION_MESSAGE } from '../ValidationMessage';
import { createDateSchema } from './CustomValidation/DateExtendedSchema';
import yup from './CustomValidation/yup-extended';
import { ExtendedDateSchemaType } from './ValidationTypes';

export const StudentInterventionValidationEditSchema = yup.object().shape({
  studentIdentifierState: yup
    .string()
    .required(VALIDATION_MESSAGE.REQUIRED)
    .mustBeNumber()
    .min(9, VALIDATION_MESSAGE.EXACT_NUMBER_LENGTH(9))
    .max(9, VALIDATION_MESSAGE.EXACT_NUMBER_LENGTH(9)),
  studentLastOrSurname: yup.string().required(VALIDATION_MESSAGE.REQUIRED),
  studentFirstName: yup.string().required(VALIDATION_MESSAGE.REQUIRED),
  birthDate: yup.string().required(VALIDATION_MESSAGE.REQUIRED),
  districtName: yup.string().required(VALIDATION_MESSAGE.REQUIRED),
  districtId: yup
    .string()
    .required(VALIDATION_MESSAGE.REQUIRED)
    .mustBeNumber()
    .min(4, VALIDATION_MESSAGE.EXACT_NUMBER_LENGTH(4))
    .max(4, VALIDATION_MESSAGE.AT_MOST_CHARS(4)),
  schoolYear: yup.string().required(VALIDATION_MESSAGE.REQUIRED),
  schoolId: yup.string().required(VALIDATION_MESSAGE.REQUIRED),
  schoolName: yup.string().required(VALIDATION_MESSAGE.REQUIRED),
  grade: yup.string().required(VALIDATION_MESSAGE.REQUIRED),
  gender: yup.string().required(VALIDATION_MESSAGE.REQUIRED),
  ethnicity: yup.string().required(VALIDATION_MESSAGE.REQUIRED),
  race: yup.string().when(['ethnicity'], {
    is: (value: string) => value !== 'Hispanic or Latino',
    then: yup.string().required(VALIDATION_MESSAGE.REQUIRED),
    otherwise: yup.string().notRequired(),
  }),
  interventionCriteria: yup.array().required(VALIDATION_MESSAGE.REQUIRED),
  interventionStartDate: (createDateSchema() as ExtendedDateSchemaType)
    .max('2999-12-31', VALIDATION_MESSAGE.MUST_BE_VALID_DATE)
    .required(VALIDATION_MESSAGE.REQUIRED)
    .min(
      yup.ref('interventionReferralDate'),
      'Date must be equal to or after Intervention Referral Date.'
    ),
  numberofSuspensionDays: yup.string(),
  tierPlacement: yup.string().required(VALIDATION_MESSAGE.REQUIRED),
  interventionReferralDate: (createDateSchema() as ExtendedDateSchemaType)
    .max('2999-12-31', VALIDATION_MESSAGE.MUST_BE_VALID_DATE)
    .required(VALIDATION_MESSAGE.REQUIRED),
  interventionDecisionDate: (createDateSchema() as ExtendedDateSchemaType).max(
    '2999-12-31',
    VALIDATION_MESSAGE.MUST_BE_VALID_DATE
  ),
  documentedReviewDate: (createDateSchema() as ExtendedDateSchemaType).max(
    '2999-12-31',
    VALIDATION_MESSAGE.MUST_BE_VALID_DATE
  ),
  cumulativeDocumentedReviewDate: (
    createDateSchema() as ExtendedDateSchemaType
  ).max('2999-12-31', VALIDATION_MESSAGE.MUST_BE_VALID_DATE),
});
